import { action } from "satcheljs";
import { IShiftEntity } from "sh-models";
import { ShiftStoreTypes } from "sh-application/../StaffHubConstants";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const updateShifts = action(
    "UPDATE_SHIFTS",
    (
        shiftsUpdated: IShiftEntity[],
        isOptimisticUpdate: boolean,
        shiftStoreType: ShiftStoreTypes,
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
    ) => ({
        shiftsUpdated: shiftsUpdated || [],
        isOptimisticUpdate: isOptimisticUpdate,
        shiftStoreType: shiftStoreType,
        viewState: viewState
    })
);

export default updateShifts;
